import { useCallback, useEffect, useRef } from 'react';

/**
 * Запись, распознанная при выключенной Истории, сохраняется задним числом,
 * когда человек Историю включает.
 *
 * Экран распознавания отдаёт результат наверх один раз (onSaved) и дальше
 * размонтируется: при выключенной Истории autoSaveItem выходит по гейту, и
 * запись не сохраняется уже никогда. Кнопка «Включить Историю, чтобы дать
 * ссылку» на экране протокола включала Историю — а ссылка так и не появлялась:
 * исходной записи нет, протоколу некуда лечь (ревью Fable 24.09). Помним
 * последнюю несохранённую и отдаём её autoSaveItem при включении.
 *
 * @returns {(taskId: string, item: object) => void} save — вместо autoSaveItem.
 */
export function useDeferredHistorySave(historyEnabled, autoSaveItem) {
  const pendingRef = useRef(null);

  useEffect(() => {
    const pending = pendingRef.current;
    if (!historyEnabled || !pending) return;
    pendingRef.current = null;
    autoSaveItem(pending.taskId, pending.item);
  }, [historyEnabled, autoSaveItem]);

  return useCallback((taskId, item) => {
    if (!historyEnabled) pendingRef.current = { taskId, item };
    autoSaveItem(taskId, item);
  }, [historyEnabled, autoSaveItem]);
}
